import humps from 'humps'
import { defineStore } from 'pinia'
import { readonly, computed, ref } from 'vue'
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
import AdventureType from '@/models/AdventureType'

export const useQuestStore = defineStore('questStore', () => {
  // state
  const currentDeckNo = ref(0)
  const adventureTypes = ref([])
  const ongoingAdventure = ref<any>(null)
  const adventureResult = ref<any>(null)

  // getters
  const getQuestTypes = readonly({
    normalQuest: 0,
    landQuest: 1,
    cooperationQuest: 2,
    eventQuest: 3,
    gacha: 4,
  })

  const getCurrentDeckNo = computed(() => currentDeckNo.value)
  const getAdventureType = computed(() => (id: Number) =>
    readonly(adventureTypes.value.find((x: any) => x.adventureType === id) || {})
  )
  const getAdventureTypes = computed(() => [...adventureTypes.value])
  const getUnclosedAdventure = computed(() => ongoingAdventure.value)
  const getAdventureResult = computed(() => adventureResult.value)

  // actions
  async function startAdventure({ adventureType, deckNo, challengeCount }) {
    const { $questsService } = useNuxtApp()
    const res = await $questsService.adventure(adventureType, deckNo, challengeCount)
    adventureResult.value = res
    currentDeckNo.value = deckNo
  }

  async function fetchCurrentAdventureTypes() {
    const { $questsService } = useNuxtApp()
    const res = await $questsService.getCurrentAdventureTypes()
    const types = res.map(r => new AdventureType(r))
    for (const adventureType of types) {
      const { heroRarityUpperLimitMap, heroRarityLowerLimitMap, heroAttributeLimitMap } = adventureType
      adventureType.limitData = []
      adventureType.attributeLimitData = []

      heroRarityUpperLimitMap.forEach(x => {
        if (x[1] != 0 && x[1] != 5) {
          let pushData = {
            rarity: x[0],
            limit: x[1],
            upper: true,
          }
          adventureType.limitData.push(pushData)
        }
      })
      heroRarityLowerLimitMap.forEach(x => {
        if (x[1] != 0 && x[1] != 5) {
          let pushData = {
            rarity: x[0],
            limit: x[1],
          }
          adventureType.limitData.push(pushData)
        }
      })
      heroAttributeLimitMap.forEach(x => {
        if (x[1] != 0) {
          let pushData = {
            attr: x[0],
            limit: x[1],
          }
          adventureType.attributeLimitData.push(pushData)
        }
      })
    }
    adventureTypes.value = types
  }

  async function checkUnclosedAdventure() {
    const { $questsService } = useNuxtApp()
    const res = await $questsService.getOngoingUserAdventureResult()
    if (res.adventureType) {
      ongoingAdventure.value = res
    }
  }

  async function closeAdventure() {
    const { $questsService } = useNuxtApp()
    await $questsService.closeAdventure()
    adventureResult.value = ongoingAdventure.value
    ongoingAdventure.value = null
  }

  function setAdventureResultViewed() {
    adventureResult.value = null
  }

  return {
    currentDeckNo,
    adventureTypes,
    ongoingAdventure,
    adventureResult,
    getQuestTypes,
    getCurrentDeckNo,
    getAdventureType,
    getAdventureTypes,
    getUnclosedAdventure,
    getAdventureResult,
    startAdventure,
    fetchCurrentAdventureTypes,
    checkUnclosedAdventure,
    closeAdventure,
    setAdventureResultViewed,
  }
})
